import { apiBase } from "../spurt/config";
import { getToken } from "../spurt/auth";
import { ApiError } from "../spurt/http";

/** GET a file that needs the bearer token (an <a href> or <img src> can't send it), as a Blob. */
export async function fetchBlob(path: string): Promise<Blob> {
  const token = getToken();
  if (!token) throw new ApiError(401, "unauthorized", "Not signed in");
  let res: Response;
  try {
    res = await fetch(apiBase() + path, { headers: { Authorization: `Bearer ${token}` }, credentials: "omit" });
  } catch {
    throw new ApiError(0, "network", "Can't reach the server");
  }
  if (!res.ok) {
    let message = res.statusText || "Request failed";
    try {
      const j = (await res.json()) as { message?: string };
      if (j.message) message = j.message;
    } catch {
      /* not JSON */
    }
    throw new ApiError(res.status, "http_" + res.status, message);
  }
  return res.blob();
}
